import { generateClient } from "aws-amplify/api";

import { listLanguages, listTranslationKeys, listTranslations } from "../graphql/queries";

const client = generateClient();

export const getLanguageDataGraphQl = async (authMode = "iam") => {
  const languages = await paginatedRequest(authMode, listLanguages, "listLanguages");
  const translationKeys = await paginatedRequest(authMode, listTranslationKeys, "listTranslationKeys");
  const translations = await paginatedRequest(authMode, listTranslations, "listTranslations");

  const data = {
    Language: languages,
    TranslationKey: translationKeys,
    Translation: translations,
  };

  return data;
};

const paginatedRequest = async (authMode, query, queryString) => {
  let translations = [];
  let nextToken = null;

  do {
    const response = await client.graphql({
      query: query,
      variables: {
        limit: 10000,
        nextToken: nextToken,
        filter: {
          _deleted: {
            attributeExists: false,
          },
        },
      },
      authMode: authMode,
    });

    const { items, nextToken: newNextToken } = response.data[queryString];
    translations = translations.concat(items);
    nextToken = newNextToken;
  } while (nextToken);

  return translations;
};
